import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import BackgroundImage from '../../BackgroundImage';
import { useStatsig } from '../../hooks/useStatsig';
import StatsigLink from '../../Links/StatsigLink';
import config from '../../../../config';

const TeamClubCard = props => {
    const { featureGates } = useStatsig();
    const {
        force = {},
        forceCardView,
        adultTeamClub,
        onClick,
        'data-testid': dataTestId,
    } = props;

    const {
        id,
        name,
        location,
        clubProfileImages,
    } = adultTeamClub;

    const locationValue = location && location.display ? location.display : '';
    const descriptionItems = [locationValue];
    const description = descriptionItems.join(' \u00B7 ');

    const isCardView = forceCardView || (force && force.cardView);

    return (
        <StatsigLink
            gate={featureGates.CLUB_LINKS_REDIRECT}
            enabledTo={`${config.nextAppHost}/club/${id}`}
            disabledTo={`/clubs/${id}`}
            onClick={onClick}
        >
            <div className={`utr-card club-card ${force && force.featured ? 'club-card-featured' : ''}`}>
                <div className={`list-view ${isCardView ? 'd-none' : 'd-none d-md-block'}`}>
                    <div className="d-flex">
                        <div className="flex-grow">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="name show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.name`}>{name}</div>
                                </div>
                                <div className="col-md-4">
                                    <div className="location show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.location`}>{locationValue || ''}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`card-view ${isCardView ? 'd-block' : 'd-block d-md-none'}`}>
                    <div className="club-details">
                        <div className="d-flex align-self-stretch">
                            <div className="flex-grow">
                                <div className="row aifs">
                                    <div className="col-8">
                                        <div className="tag-container">
                                            {!!(force && force.featured) && <div className={`tag tag-featured tag-sm mr8`} data-testid={dataTestId && `${dataTestId}.featured-tag`}>Featured</div>}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className={`avatar-wrapper`}>
                                            <BackgroundImage
                                                baseUrl={'/v1/club/'}
                                                defaultImage={'/img/v2/icons/icon-avatar-club.svg'}
                                                images={clubProfileImages}
                                                imageType={'profile'}
                                                parentStylesClass={'avatar'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="empty-div" />
                        <div className={`name`} data-testid={dataTestId && `${dataTestId}.mobile.name`}>
                            {<Dotdotdot clamp={2}>{name}</Dotdotdot>}
                        </div>
                        <div className="details show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.location`}>{description}</div>
                    </div>
                </div>
            </div>
        </StatsigLink>
    );
};

TeamClubCard.defaultProps = {
    'data-testid': null,
};

export default TeamClubCard;
